export default __webpack_public_path__ + "locales/fr/Payments.json?hash=b23673b916869f01f90f3eeca4def823";